let storeId = 0;
export function getUniqueStore() {
  return ++storeId;
}

export const ENDPOINT_DATA_OBJECT_LIST = 'endpoints/dataObjectList';

export const CUSTOMER_CUSTOMER = 'Customer';
export const CUSTOMER_CUSTOMERCONFIG = 'customer/CustomerConfig';
export const CUSTOMER_ATTRIBUTE = 'customer/Attribute';
export const CUSTOMER_SPECIAL_PRICES = 'customer/CustomerSpecialPrices';

export const PRODUCTS_PRODUCT = 'products/Product';
export const PRODUCTS_PRODUCTCONFIG = 'products/ProductConfig';
export const PRODUCTS_WAREHOUSE = 'products/Warehouse';
export const PRODUCTS_STOCK_ADJUSTMENT_REASON = 'products/StockAdjustmentReason';
export const PRODUCTS_STOCK_TRANSFER_REASON = 'products/StockTransferReason';
export const PRODUCTS_STOCK_TRANSACTION = 'products/StockTransaction';
export const PRODUCTS_LOT_ATTRIBUTE = 'products/LotAttribute';
export const PRODUCTS_BIN_LOCATION = 'products/BinLocation';
export const PRODUCTS_BIN_LOCATION_STOCK_QUANTITY = 'compositeRecords/products/BinLocationStockQuantity';
export const PRODUCTS_BIN_LOCATION_RANGE_CRITERIA = 'actionCriteria/products/BinLocationRangeCriteria';
export const PRODUCTS_PRODUCT_LOT = 'products/ProductLot';
export const PRODUCTS_PRODUCT_LOT_STOCK_QUANTITY = 'compositeRecords/products/ProductLotStockQuantity';
export const PRODUCTS_GOODS_RECEIPT = 'products/GoodsReceipt';
export const PRODUCTS_STOCK_ADJUSTMENT = 'products/StockAdjustment';
export const PRODUCTS_STOCK_TRANSFER = 'products/StockTransfer';
export const PRODUCTS_STOCK_QUANTITY = 'products/StockQuantity';
export const PRODUCT_ATTRIBUTE = 'products/Attribute';
export const PRODUCT_PRICING_ATTRIBUTE = 'products/PricingAttribute';
export const PRODUCT_PRICE_LIST = 'products/PriceMatrix';
export const PRODUCTS_WEIGHT_TYPE = 'products/WeightType';

// Product ENUMs
export const PRODUCTS_PRICE_MATRIX_APPLICATION_METHOD = 'products/PriceMatrixApplicationMethod';
export const PRODUCTS_PRICE_MATRIX_PRICE_BASE = 'products/PriceMatrixPriceBase';
export const PRODUCTS_PRICE_SOURCE_TYPE = 'products/PriceSourceType';
export const PRODUCTS_RANGE_TYPE = 'products/RangeType';
export const PRODUCTS_UNIT_OF_MEASEURE_FACTOR_DIRECTION = 'products/UnitOfMeasureFactorDirection';
export const PRODUCTS_VALUATION_METHOD = 'products/ValuationMethod';
export const PRODUCTS_WAREHOUSE_TYPE = 'products/WarehouseType';

export const SUPPLIER_SUPPLIER = 'supplier/Supplier';
export const SUPPLIER_SUPPLIERCONFIG = 'supplier/SupplierConfig';

export const SYSTEM_SMTPCONFIG = 'system/SmtpConfig';
export const SYSTEM_SMTPLOG = 'system/SmtpLog';
export const SYSTEM_SYSTEMUSER = 'system/SystemUser';
export const SYSTEM_COMPANY = 'system/Company';
export const SYSTEM_USERROLE = 'system/UserRole';
export const SYSTEM_SYSTEM_PRINTER = 'system/SystemPrinter';
export const SYSTEM_REPORT_OUTPUT_TYPE = 'system/ReportOutputType';

export const UTIL_NETWORK_PRINTER = 'util/NetworkPrinters';

export const COMMON_ISOCOUNTRY = 'common/ISOCountry';
export const COMMON_ISOCURRENCY = 'common/ISOCurrency';
export const COMMON_ISO_UNIT_OF_MEASURE = 'common/ISOUnitOfMeasure';
export const COMMON_COUNTRY = 'Country';
export const COMMON_CURRENCY = 'Currency';
export const COMMON_ORDERCONFIG = 'sales/OrderConfig';
export const COMMON_REPORT_TEMPLATES = 'common/ReportTemplate';

// Common ENUMs
export const COMMON_ATTRIBUTE_TYPE = 'common/AttributeType';
export const COMMON_DOCUMENT_TYP = 'common/DocumentType';
export const COMMON_IMPORT_STEP_TYPE = 'common/ImportStepType';
export const COMMON_LOT_ATTRIBUTE_TYPE = 'common/LotAttributeType';
export const COMMON_DOCUMENT_STATUS = 'common/DocumentStatus';
export const COMMON_MARGIN_RECALCULATION_METHOD = 'common/MarginRecalculationMethod';
export const COMMON_NOMINAL_POSTING_TYPE = 'common/NominalPostingType';
export const COMMON_NUMERIC_CONFIG = 'common/NumericConfig';
export const COMMON_POSTING_AMOUNT_TYPE = 'common/PostingAmountType';
export const COMMON_SALES_MARGIN_TYPE = 'common/SalesMarginType';

export const COMPANY_VATCODE = 'company/VATCode';
export const COMPANY_VATCATEGORY = 'company/VATCategory';
export const COMPANY_COMPANY = 'company/Company';
export const COMPANY_USER = 'company/CompanyUser';
export const COMPANY_FINANCIALCALENDAR = 'company/FinancialCalendar';

// Company ENUMs
export const COMPANY_FINANCIAL_CALENDAR_TYPE = 'company/FinancialCalendarType';
export const COMPANY_FINANCIAL_PERIOD_STATUS = 'company/FinancialPeriodStatus';
export const COMPANY_PAYMENT_TERM_DATE = 'company/PaymentTermDate';
export const COMPANY_VAT_INDICATOR = 'company/VATIndicator';

export const SALES_ORDER = 'sales/Order';
export const SALES_ACKNOWLEDGEMENT = 'sales/Acknowledgement';
export const SALES_PRICE_BAND = 'sales/PriceBand';
export const SALES_PRICE_BAND_REFERENCE = 'sales/PriceBandReference';
export const SALES_ATTRIBUTE = 'sales/Attribute';

export const SALES_INVOICE = 'salesLedger/SalesInvoice';
export const SALES_TRANSACTION = 'salesLedger/SalesTransaction';
export const SALES_PAYMENTTERM = 'salesLedger/SalesPaymentTerm';
export const SALES_RECEIPT = 'salesLedger/SalesReceipt';
export const SALES_ALLOCATION = 'salesLedger/SalesAllocation';

// Sales ENUMs
export const SALES_ORDER_STATUS = 'sales/OrderStatus';
export const SALES_PRICE_ORIGIN_TYPE = 'sales/PriceOriginType';

export const DIARY_EVENT = 'Diary/Task';
export const DIARY_TYPE = 'diary/Type';
export const DIARY_RESULT = 'diary/Result';
export const DIARY_ATTRIBUTE = 'diary/Attribute';
export const DIARY_NOTE = 'diary/Note';

// Diary ENUMs
export const DIARY_INVOLVES = 'diary/Involves';

export const NOMINAL_NOMINALCONFIG = 'nominal/NominalConfig';
export const NOMINAL_NOMINAL = 'nominal/Nominal';
export const NOMINAL_DIMENSION = 'nominal/Dimension';
export const NOMINAL_BUSINESSCATEGORY = 'nominal/NominalBusinessCategory';
export const NOMINAL_PRODUCTCATEGORY = 'nominal/NominalProductCategory';
export const NOMINAL_COMMONACCOUNTSET = 'nominal/NominalCommonAccountSet';
export const NOMINAL_CUSTOMERACCOUNTSET = 'nominal/NominalCustomerAccountSet';
export const NOMINAL_SUPPLIERACCOUNTSET = 'nominal/NominalSupplierAccountSet';
export const NOMINAL_PRODUCTACCOUNTSET = 'nominal/NominalProductAccountSet';
export const NOMINAL_POSTING = 'nominal/PostingPreview';
export const NOMINAL_TRANSACTION = 'nominal/NominalTransaction';
export const NOMINAL_REPORTCATEGORY = 'nominal/NominalReportCategory';

export const VAT_BUSINESSCATEGORY = 'vat/VATBusinessCategory';
export const VAT_PRODUCTCATEGORY = 'vat/VATProductCategory';
export const VAT_RATE = 'vat/VATRate';
export const VAT_AUTHORITY = 'vat/VATAuthority';
export const VAT_TRANSACTION = 'vat/VATTransaction';

export const SYSTEM_SCREEN = 'system/Screen';
export const SYSTEM_FOLDER = 'system/Folder';
export const PRICE_LIST_DISCOUNT_TYPE = 'products/DiscountType';
export const PRICE_LIST_PREVIEW = 'products/PriceListPreview';

export const COMMON_FEEDBACK = 'common/Feedback';

export const CUSTOMER_NOTE_TYPE = 'customer/NoteType';
export const PRODUCT_NOTE_TYPE = 'products/NoteType';
export const SUPPLIER_NOTE_TYPE = 'supplier/NoteType';
export const SALES_NOTE_TYPE = 'sales/NoteType';
export const NOMINAL_NOTE_TYPE = 'nominal/NoteType';

export const BANK_BANK = 'bank/Bank';
